import { IBaseResponseData, ICongress } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of congresses from the `/congress` endpoint.
 */
export interface ICongressResponse extends IBaseResponseData {
  congress: ICongress[]
}
